import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import "./ThemeLanguageToggle.css";

const ThemeLanguageToggle = () => {
  const { i18n } = useTranslation();
  
  // Initialize from localStorage
  const [theme, setTheme] = useState(() => {
    return localStorage.getItem("theme") || "light";
  });
  
  const [language, setLanguage] = useState(() => {
    return localStorage.getItem("language") || "fa";
  });

  // Sync with i18n on mount
  useEffect(() => {
    const savedLang = localStorage.getItem("language") || "fa";
    if (i18n.language !== savedLang) {
      i18n.changeLanguage(savedLang);
    }
    const savedTheme = localStorage.getItem("theme") || "light";
    document.documentElement.setAttribute("data-theme", savedTheme);
    document.documentElement.setAttribute("dir", savedLang === "fa" ? "rtl" : "ltr");
  }, [i18n]);

  const toggleTheme = () => {
    const newTheme = theme === "light" ? "dark" : "light";
    setTheme(newTheme);
    localStorage.setItem("theme", newTheme);
    document.documentElement.setAttribute("data-theme", newTheme);
    
    // Dispatch custom event to sync with App.js
    window.dispatchEvent(new CustomEvent('themeChange', { detail: { theme: newTheme } }));
  };

  const changeLanguage = (lang) => {
    setLanguage(lang);
    localStorage.setItem("language", lang);
    i18n.changeLanguage(lang);
    document.documentElement.setAttribute("dir", lang === "fa" ? "rtl" : "ltr");
    document.documentElement.setAttribute("lang", lang);
    
    // Update body class for any global styles
    if (lang === "fa") {
      document.querySelector("body")?.classList.add("dirRTL");
      document.querySelector("body")?.classList.remove("dirLTR");
    } else {
      document.querySelector("body")?.classList.add("dirLTR");
      document.querySelector("body")?.classList.remove("dirRTL");
    }
    
    // Dispatch custom event to sync with App.js
    window.dispatchEvent(new CustomEvent('languageChange', { detail: { language: lang } }));
  };

  return (
    <div className="theme-language-controls">
      {/* Theme Toggle */}
      <button
        className="theme-toggle-btn"
        onClick={toggleTheme}
        aria-label="Toggle theme"
        title={theme === "light" ? "Switch to Dark Mode" : "Switch to Light Mode"}
      >
        {theme === "light" ? (
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" fill="currentColor"/>
          </svg>
        ) : (
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="5" fill="currentColor"/>
            <path d="M12 1v2m0 18v2M4.22 4.22l1.42 1.42m12.72 12.72l1.42 1.42M1 12h2m18 0h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
          </svg>
        )}
      </button>

      {/* Language Selector */}
      <div className="language-selector">
        <button
          className={`language-btn ${language === "en" ? "active" : ""}`}
          onClick={() => changeLanguage("en")}
          title="English"
        >
          <span className="flag-icon">🇬🇧</span>
          <span className="language-text">EN</span>
        </button>
        <button
          className={`language-btn ${language === "fa" ? "active" : ""}`}
          onClick={() => changeLanguage("fa")}
          title="فارسی"
        >
          <span className="flag-icon">🇮🇷</span>
          <span className="language-text">FA</span>
        </button>
      </div>
    </div>
  );
};

export { ThemeLanguageToggle };